const TextboxObject = (fabric) => {
    fabric.CustomTextbox = fabric.util.createClass(fabric.Textbox, {
        type: 'CustomTextbox',

        initialize: function (element, options) {
            this.callSuper('initialize', element, options)
            // options && this.set('borderColor', options.borderColor || '#DADADA')
            options &&
                this.set(
                    'borderColor',
                    options.borderColor || 'rgba(255, 255, 255, 0)'
                )
            options && this.set('borderWidth', options.borderWidth || 1)
            options && this.set('padding', options.padding || 5)
            options &&
                this.set('strokeDashArray', options.strokeDashArray || [])
            options &&
                this.set('strokeLineCap', options.strokeLineCap || 'butt')
            options &&
                this.set(
                    'backgroundColor',
                    options.backgroundColor || 'rgba(255, 255, 255, 0)'
                )
        },

        _render: function (ctx) {
            //  console.log('CTX:', ctx)
            var rectX = -this.width / 2 - this.padding
            var rectY = -this.height / 2 - this.padding
            var rectWidth = this.width + this.padding * 2
            var rectHeight = this.height + this.padding * 2

            ctx.fillStyle = this.backgroundColor
            ctx.fillRect(rectX, rectY, rectWidth, rectHeight)

            this.callSuper('_render', ctx)

            if (this.strokeDashArray && this.strokeDashArray.length > 0) {
                ctx.setLineDash(this.strokeDashArray) // Use setLineDash instead of strokeDashArray
            }

            if (this.strokeLineCap) {
                ctx.lineCap = this.strokeLineCap
            }

            var borderX = rectX - this.borderWidth / 2
            var borderY = rectY - this.borderWidth / 2
            var borderWidth = rectWidth + this.borderWidth
            var borderHeight = rectHeight + this.borderWidth

            ctx.strokeStyle = this.borderColor
            ctx.lineWidth = this.borderWidth

            ctx.strokeRect(borderX, borderY, borderWidth, borderHeight)

            ctx.setLineDash([])
        }
    })

    fabric.CustomTextbox.fromObject = function (object, callback) {
        // Simulate async operation with setTimeout or fetch data as needed
        callback &&
            setTimeout(() => {
                const instance = new fabric.CustomTextbox(object.text, object) // Ensure all relevant properties are passed
                callback(instance)
            }, 0)
    }

    fabric.CustomTextbox.async = true

    return fabric
}

export default TextboxObject
